import { UpdateInstallationFailedRadiatorRequest } from '@lib/api';
import i18n from 'i18next';
import * as yup from 'yup';

export const RadiatorInstallationFailedSchema: yup.ObjectSchema<UpdateInstallationFailedRadiatorRequest> = yup.object({
  radiatorNotAccessible: yup.boolean().nullable(),
  incompatibleValve: yup.boolean().nullable(),
  valvePinBlocked: yup.boolean().nullable(),
  valveIsLeaking: yup.boolean().nullable(),
  valveCantCompletelyOpen: yup.boolean().nullable(),
  installationNotPossible: yup.boolean().nullable(),
  installationNotPossibleDescription: yup
    .string()
    .nullable()
    .when('installationNotPossible', {
      is: true,
      then: (schema) => schema.trim().required(i18n.t('required', { ns: 'common' })),
    }),
});
// .required()
// .test('at-least-one-option', i18n.t('selectOption', { ns: 'misc' }), (data) => {
//   return Object.values(data).some((value) => value === true || data.installationNotPossibleDescription !== '');
// });
